
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/usr/src/app/ui/shared/avatar/jst/_avatar.handlebars";
import "/usr/src/app/ui/features/discussion_topic/jst/_author_link.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/usr/src/app/ui/features/discussion-topic/jst/-entry-content';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n<a\n    href=\"#\"\n    class=\"collapsable collapse-discussion pad-box-mini\"\n    role=\"button\"\n    tabindex=\"0\"\n    data-event=\"toggleCollapsed\">\n    <span aria-live=\"assertive\" class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "collapse_subdiscussion_89af1f5c", "Collapse Subdiscussion", options) : helperMissing.call(depth0, "t", "collapse_subdiscussion_89af1f5c", "Collapse Subdiscussion", options)))
    + "</span>\n</a>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = self.invokePartial(partials['ui/shared/avatar/jst/_avatar.handlebars'], 'ui/shared/avatar/jst/_avatar.handlebars', (depth0 && depth0.author), helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          <span>";
  if (helper = helpers.hiddenName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.hiddenName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n        ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = self.invokePartial(partials['ui/features/discussion_topic/jst/_author_link.handlebars'], 'ui/features/discussion_topic/jst/_author_link.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <li><a data-pushstate href=\"#entry-";
  if (helper = helpers.parent_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.parent_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"><i class=\"icon-replied\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "discussions.entry_content.go_to_parent", "Go To Parent", options) : helperMissing.call(depth0, "t", "discussions.entry_content.go_to_parent", "Go To Parent", options)))
    + "</a></li>\n        ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <li><a href=\"#topic\" data-pushstate><i class=\"icon-discussion\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "discussions.entry_content.go_to_topic", "Go To Topic", options) : helperMissing.call(depth0, "t", "discussions.entry_content.go_to_topic", "Go To Topic", options)))
    + "</a></li>\n        ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <li><a data-event=\"edit\" href=\"#\"><i class=\"icon-edit\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "edit_c5fbea07", "Edit", options) : helperMissing.call(depth0, "t", "edit_c5fbea07", "Edit", options)))
    + "</a></li>\n          <li><a data-event=\"remove\" href=\"#\"><i class=\"icon-trash\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "delete_a6efa79d", "Delete", options) : helperMissing.call(depth0, "t", "delete_a6efa79d", "Delete", options)))
    + "</a></li>\n        ";
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isAuthorsEntry), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program16(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <li><a data-event=\"edit\" class=\"disabled\"><i class=\"icon-edit\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "edit_disabled_e6a5ea0a", "Edit (Disabled)", options) : helperMissing.call(depth0, "t", "edit_disabled_e6a5ea0a", "Edit (Disabled)", options)))
    + "</a></li>\n            <li><a data-event=\"remove\" class=\"disabled\"><i class=\"icon-trash\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "delete_disabled_3196ce47", "Delete (Disabled)", options) : helperMissing.call(depth0, "t", "delete_disabled_3196ce47", "Delete (Disabled)", options)))
    + "</a></li>\n          ";
  return buffer;
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <li><a href=\"";
  if (helper = helpers.speedgraderUrl) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.speedgraderUrl); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"><i class=\"icon-speed-grader\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "discussions.entry_content.open_in_speedgrader", "Open in SpeedGrader", options) : helperMissing.call(depth0, "t", "discussions.entry_content.open_in_speedgrader", "Open in SpeedGrader", options)))
    + "</a></li>\n        ";
  return buffer;
  }

function program20(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"discussion-fyi\">";
  stack1 = (helper = helpers.__i18nliner_escape || (depth0 && depth0.__i18nliner_escape),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.editor_href), options) : helperMissing.call(depth0, "__i18nliner_escape", (depth0 && depth0.editor_href), options));
  stack1 = (helper = helpers.__i18nliner_concat || (depth0 && depth0.__i18nliner_concat),options={hash:{},data:data},helper ? helper.call(depth0, "<a href=\"", stack1, "\">$1</a>", options) : helperMissing.call(depth0, "__i18nliner_concat", "<a href=\"", stack1, "\">$1</a>", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': (stack1),
    'editor.display_name': (((stack1 = (depth0 && depth0.editor)),stack1 == null || stack1 === false ? stack1 : stack1.display_name)),
    'edited_at': ((depth0 && depth0.edited_at)),
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "discussions.entry_content.edited_comment", "Edited by *%{editor.display_name}* on %{edited_at}", options) : helperMissing.call(depth0, "t", "discussions.entry_content.edited_comment", "Edited by *%{editor.display_name}* on %{edited_at}", options)))
    + "</div>\n  ";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <div class=\"comment_attachments\">\n      ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.attachments), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  ";
  return buffer;
  }
function program23(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <div><a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\""
    + escapeExpression((helper = helpers.mimeClass || (depth0 && depth0.mimeClass),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0['content-type']), options) : helperMissing.call(depth0, "mimeClass", (depth0 && depth0['content-type']), options)))
    + "\" title=\"";
  if (helper = helpers.filename) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.filename); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.display_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.display_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a></div>\n      ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <a role=\"button\" class=\"discussion-reply-action entry-control\"\n       data-event=\"addReply\"\n       href=\"#\">\n      <i class=\"icon-replied\"></i>\n      <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "discussions.entry_content.write_a_reply", "Reply", options) : helperMissing.call(depth0, "t", "discussions.entry_content.write_a_reply", "Reply", options)))
    + "</span>\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "reply_to_comment_72d96728", "Reply to Comment", options) : helperMissing.call(depth0, "t", "reply_to_comment_72d96728", "Reply to Comment", options)))
    + "</span>\n    </a>\n  ";
  return buffer;
  }

function program27(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <button class=\"discussion-rate-action entry-control\"\n       data-event=\"toggleLike\"\n       aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "discussions.entry_content.like_entry", "Like entry", options) : helperMissing.call(depth0, "t", "discussions.entry_content.like_entry", "Like entry", options)))
    + "\">\n      <i class=\"icon-like\"></i>\n    </button>\n  ";
  return buffer;
  }

  buffer += "<header class=\"entry-header discussion-section admin-link-hover-area clearfix\">\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.collapsable), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hiddenName), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <div class=\"discussion-header-content right-of-avatar\">\n    <div class=\"pull-left span4 discussion-header__metadata\">\n      <h2 class=\"discussion-title\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hiddenName), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </h2>\n      <div class=\"discussion-pubdate hide-if-collapsed\">"
    + escapeExpression((helper = helpers.friendlyDatetime || (depth0 && depth0.friendlyDatetime),options={hash:{
    'pubdate': (true),
    'contextSensitive': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.created_at), options) : helperMissing.call(depth0, "friendlyDatetime", (depth0 && depth0.created_at), options)))
    + "</div>\n      <div class=\"show-if-collapsed discussion-subtitle summary ellipsis\">";
  if (helper = helpers.summary) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.summary); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n    </div>\n    <div class=\"admin-links hide-if-collapsed\">\n      <a role=\"button\" class=\"al-trigger dim-till-hover\" href=\"#\">\n        <i class=\"icon-more standalone-icon\" aria-hidden=\"true\"></i>\n        <span class=\"screenreader-only\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.entry_content")
  },data:data},helper ? helper.call(depth0, "discussions.entry_content.manage_discussion_entry", "Manage Discussion Entry", options) : helperMissing.call(depth0, "t", "discussions.entry_content.manage_discussion_entry", "Manage Discussion Entry", options)))
    + "\n        </span>\n      </a>\n      <ul class=\"al-options\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.parent_id), {hash:{},inverse:self.program(11, program11, data),fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.program(15, program15, data),fn:self.program(13, program13, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.canModerate), (depth0 && depth0.canReply), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.canModerate), (depth0 && depth0.canReply), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.speedgraderUrl), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </ul>\n    </div>\n    <div class=\"discussion-header-right\">\n      <div class=\"headerBadges show-if-collapsed\"></div>\n    </div>\n  </div>\n</header>\n<div class=\"discussion-section message_wrapper hide-if-collapsed\">\n  <span class=\"message-notification\" data-bind=\"messageNotification\"></span>\n  <div data-bind=\"message\" class=\"message user_content\">"
    + escapeExpression((helper = helpers.convertApiUserContent || (depth0 && depth0.convertApiUserContent),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.message), options) : helperMissing.call(depth0, "convertApiUserContent", (depth0 && depth0.message), options)))
    + "</div>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.editor), {hash:{},inverse:self.noop,fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.attachments), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n<div class=\"entry-controls hide-if-collapsed hide-if-replying\">\n  <div class=\"notification\" data-bind=\"notification\"></div>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inlineReplyLink), {hash:{},inverse:self.noop,fn:self.program(25, program25, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canRate), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <span class=\"discussion-rating\"></span>\n</div>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/features/discussion_topic/jst/_entry_content.handlebars', templates['/usr/src/app/ui/features/discussion-topic/jst/-entry-content']);
    ;
    ;
    export default templates[name];
  